var _CrehanaIso, _CloseSmall;
import CrehanaIso from "@crehana/icons/logos/CrehanaIso";
import ArrowIosLeft from "@crehana/icons/outline/ArrowIosLeft";
import CloseSmall from "@crehana/icons/outline/CloseSmall";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Clamp, TextTag } from "@crehana/ui";
import cn from "classnames";
import { useMainMenuContext, useMainMenuTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DrawerHeader = function DrawerHeader(_ref) {
  var className = _ref.className,
    title = _ref.title,
    onDismiss = _ref.onDismiss,
    onGoBack = _ref.onGoBack,
    isNew = _ref.isNew;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme;
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  return /*#__PURE__*/_jsxs("header", {
    className: cn('w-full h-56 px-16 flex items-center justify-between flex-shrink-0', onGoBack ? 'font-subtitle3' : 'font-body3', theme.submenu.logoColorClassName, className),
    children: [onGoBack ? /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: onGoBack,
      className: "flex items-center",
      children: [/*#__PURE__*/_jsx(ArrowIosLeft, {
        size: 24,
        ignoreColor: true,
        className: cn('fill-current mr-16', theme.submenu.accentIconColorClassName)
      }), /*#__PURE__*/_jsx(Clamp, {
        clamp: 1,
        children: title
      }), isNew && /*#__PURE__*/_jsx(TextTag, {
        label: t('ACADEMY_TAG'),
        type: "green",
        className: "bg-secondary-main ml-8"
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [_CrehanaIso || (_CrehanaIso = /*#__PURE__*/_jsx(CrehanaIso, {
        size: 24,
        ignoreColor: true,
        className: "mr-16 fill-current"
      })), title]
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onDismiss,
      className: cn('w-32 h-32 flex items-center justify-end flex-shrink-0', theme.submenu.textColorClassName),
      children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
        size: 24,
        ignoreColor: true,
        className: "fill-current"
      }))
    })]
  });
};
export default DrawerHeader;